module.exports = {
  title: '临时企业列表',
  route: {
    path: '/user-manage',
    children: {
      path: 'temporary-user-list',
    },
  },
};
